import ValidationService from '../../../lib/validation';
import config from '../../../config';

const validateName = values => {
  if (config.askPersonalInformationDuringOrderSim) {
    return {
      givenName: ValidationService.validatePresence(values.givenName),
      familyName: ValidationService.validatePresence(values.familyName),
    };
  }

  return {
    fullName: ValidationService.validatePresence(values.fullName),
  };
};

const validateAddress = values => {
  if (!config.askPersonalInformationDuringOrderSim) {
    return null;
  }

  return {
    idAddress: (() => {
      const address = values && values.idAddress;
      return {
        street1: ValidationService.validateBillingAddressField(address ? address.street1 : ''),
        street2: ValidationService.validateBillingAddressField(address ? address.street2 : '', {
          presenceNotRequired: true,
        }),
        postCode: ValidationService.validatePostCode(address ? address.postCode : ''),
        city: ValidationService.validateBillingAddressField(address ? address.city : ''),
        stateOrProvince: ValidationService.validateBillingAddressField(address ? address.stateOrProvince : ''),
      };
    })(),
  };
};

const validateIdentification = values => {
  return {
    identification: {
      identificationId: (() => {
        const identification = values && values.identification;
        const identificationId = (identification && identification.identificationId) || '';
        return ValidationService.validatePresence(identificationId);
      })(),
    },
  };
};

const validatePhoneNumber = values => {
  if (!config.askPersonalInformationDuringOrderSim) {
    return null;
  }

  const { contactPhoneNumber } = values;
  return {
    contactPhoneNumber: ValidationService.validatePhoneNumber(contactPhoneNumber),
  };
};

const validate = values => ({
  ...validateName(values),
  birthdate: ValidationService.validatebirthDate(values.birthdate),
  nationality: ValidationService.validatePresence(values.nationality),
  ...validateIdentification(values),
  ...validateAddress(values),
  ...validatePhoneNumber(values),
});

export default validate;
